import { useLang } from '@/i18n';
import EfBanner from 'elem/ui/ef-banner';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionD');
    const { locale = 'us' } = useRouter();
    const NAImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724577259249/2560_R3_runtime.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724577259412/1024_R3_runtime.jpg',
    };
    const EUImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724998261596/eu1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725345635320/1024_R3_runtime%20(1).jpg',
    };
    const UKImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724998262296/uk1.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724998262412/uk2.jpg',
    };
    const PHImg = {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751090581273/G.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1751090581168/G-m.jpg',
    };

    const imgLocale: any = {
        us: NAImg,
        ca: NAImg,
        br: NAImg,
        mx: NAImg,
        uk: UKImg,
        eu: EUImg,
        de: EUImg,
        fr: EUImg,
        it: EUImg,
        es: EUImg,
        ph: PHImg,
    };
    const imgA = imgLocale[locale] || imgLocale['eu'];
    const configs = {
        pc: imgA.pc,
        h5: imgA.h5,
        label: t('label'),
        title: t('title'),
        desc: t('desc'),
    };

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfBanner {...configs} position="hoverR" />
        </div>
    );
}
